export const RECEIVE_INSTITUTION_EARNINGS = 'RECEIVE_INSTITUTION_EARNINGS';
